class ProductOptions extends HTMLElement {
		constructor() {
				super();
		}
		connectedCallback() {
				(this.first_variant_available = "true" === this.dataset.firstVariantAvailable),
						(this.is_product_page = null !== this.closest(".product-page--root")),
						(this.labels = this.querySelectorAll(".disclosure--root, .radios--header")),
						(this.options_container = this.querySelector(".product-options--container")),
						(this.option_inputs = this.options_container.querySelectorAll('[data-item="disclosure"], [data-item="radio"]')),
						(this.size_chart = this.querySelector(".product-options--option .product-size-chart--root")),
						(this.variants = JSON.parse(this.querySelector("[id*=product-options--json]").innerHTML)),
						this.getAvailableVariants(),
						this.disableEmptyOptions(),
						this.optionChangeListener(),
						this.updateDisabledOptions(this.first_variant_available),
						this.size_chart && this.moveSizeChart();
		}
		disconnectedCallback() {
				this.option_inputs.off("change.ProductOptions");
		}
		getAvailableVariants() {
				(this.available_variants = []),
						this.variants.forEach((t) => {
								t.available && this.available_variants.push(t.options);
						});
		}
		disableEmptyOptions() {
				const a = this.available_variants.flat();
				var t = this.options_container.querySelectorAll(".radios--input, .disclosure--option");
				t.length &&
						t.forEach((t) => {
								var e = this.getOptionValue(t);
								a.includes(e) || t.setAttribute("data-empty", !0);
						});
		}
		getOptionValue(t) {
				return t.getAttribute("data-value") ? t.getAttribute("data-value") : t.value;
		}
		optionChangeListener() {
				this.option_inputs.on("change.ProductOptions", (t) => {
						const i = [];
						this.options_container.querySelectorAll('[data-item="disclosure"], [data-item="radio"]:checked').forEach((t) => {
								var e = t.closest(".product-options--option").dataset.index;
								i.push({ index: e, value: t.value });
						});
						let o = !1;
						this.variants.every((e) => {
								let a = !0;
								return (
										i.forEach((t) => {
												a = a && e.options[t.index] === t.value;
										}),
										!a || ((o = e), !1)
								);
						}),
								this.updateVariant(o, t.target);
				});
		}
		updateVariant(t, e) {
			console.log( t );
			
			if ( engraving_variants ) {
				
				get_preview_img(t.id,t)
				
			}
			
			this.updateDisabledOptions(t.available, e), this.is_product_page && this.updateHistoryState(t.id), window.trigger(`theme:product:${this.dataset.id}:variantChanged`, { variant: t });
		}
		updateHistoryState(t) {
				let e = "" + location.origin + location.pathname;
				t && (e += "?variant=" + t), history.replaceState({ path: e }, "", e);
		}
		updateDisabledOptions(t, e = !1) {
				var i = this.options_container.querySelectorAll(".radios--input, .disclosure--option");
				if (i.length) {
						const s = [];
						i.forEach((t) => {
								t.removeAttribute("data-unavailable"), (!t.checked && "true" !== t.getAttribute("aria-current")) || s.push(t);
						});
						var o = this.options_container.querySelectorAll(".disclosure--current-option");
						let a;
						!1 === e ? ((e = s[0]), (a = this.getOptionValue(e))) : e.classList.contains("disclosure--input") ? ((a = e.value), (e = s.find((t) => t.getAttribute("data-value") === a))) : (a = e.value);
						const r = [],
								n =
										(e
												.closest(".radios--container, .disclosure--form")
												.querySelectorAll(".radios--input, .disclosure--option")
												.forEach((t) => {
														var e = this.getOptionValue(t);
														e !== a && r.push(e);
												}),
										r);
						this.available_variants.forEach((t) => {
								t.includes(a) && t.forEach((t) => n.push(t));
						}),
								i.forEach((t) => {
										var e = this.getOptionValue(t);
										n.includes(e) || t.setAttribute("data-unavailable", !0);
								}),
								t ? o && o.forEach((t) => t.setAttribute("data-unavailable", !1)) : (s.forEach((t) => t.setAttribute("data-unavailable", !0)), o && o.forEach((t) => t.setAttribute("data-unavailable", !0)));
				}
		}
		moveSizeChart() {
				this.size_chart.parentNode.querySelector("label").parentNode.appendChild(this.size_chart), this.size_chart.removeAttribute("style");
		}
}
const productOptionsEl = customElements.get("product-options-root");
productOptionsEl || customElements.define("product-options-root", ProductOptions);
